import { Button, CircularProgress, TextField } from "@mui/material";
import StorylineServerProxy  from "../storyline-proxy/storyline-proxy";
import { useEffect, useRef, useState } from "react";

export default function RunScrapers(){

    let [isRunning, setIsRunning] = useState(false);
    let [runStatus, setRunStatus] = useState("");
    let [isAborting, setIsAborting] = useState(false);

    let [triggerPoll, setTriggerPoll] = useState(false);

    function handleRunClick(){
        StorylineServerProxy.runScrapers(true, true);
    }

    function handleRunWithWindowClick(){
        StorylineServerProxy.runScrapers(true, false);
    }


    useEffect(() => {
        handlePollStatus();
        setTimeout(() => setTriggerPoll(!triggerPoll), 1000);
    }, [triggerPoll])

    function handlePollStatus(){
        StorylineServerProxy.isScrapingRunning().then(response => { 
            if(response){
                if(isAborting && !response.isRunning){
                    setIsAborting(false);
                }
                setIsRunning(response.running); 
            }
        });
        StorylineServerProxy.scrapingStatus().then(response => {
            if(response){
                if(response.status){
                    setRunStatus(response.status.join("\n"));
                }
                else{
                    setRunStatus("Invalid response from server");
                }
            }
        });
        
    }

    function handleAbortClick(){
        setIsAborting(true);
        StorylineServerProxy.abortScraping();
    }

    return(
        <> 
            <TextField multiline rows={6} value={runStatus} sx={{ width:10/10 }}></TextField>
            <br/>
            { isRunning?<CircularProgress />:<><Button onClick={handleRunClick}>Run</Button><Button onClick={handleRunWithWindowClick}>Run with window</Button></>}
            { isRunning?(isAborting?<CircularProgress />:<Button onClick={handleAbortClick}>Abort</Button>):<></>}
        </>
    )
}